<template>
  <label class="terms-checkbox">
    <input required type="checkbox"
           :value="value"
           @input="$emit('input', $event.target.checked)">
    <span v-html="`${$t('text.terms')}*`"/>
  </label>
</template>

<script>
export default {
  name: 'TermsCheckbox',
  props: {
    value: {
      required: true
    }
  }
}
</script>


